/**
 * Authenticated planning at /tenant/planning.
 * Standard page shell (matches Transformations) + chat / Preview workspace.
 */

import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import PlanningChatPage from '@/pages/ai/PlanningChatPage';

export const PlanningPage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="flex h-[calc(100vh-11rem)] min-h-[420px] flex-col overflow-hidden bg-[var(--color-secondary-bg)]">
      <div className="container mx-auto flex min-h-0 flex-1 flex-col overflow-hidden px-2 py-2">
        <div className="mb-4 shrink-0">
          <h1 className="text-xl font-bold text-[var(--color-surface-text)]">{t('planning.page.title')}</h1>
          <p className="text-sm text-[var(--color-secondary-text)]">{t('planning.page.subtitle')}</p>
        </div>

        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <PlanningChatPage workspace />
        </div>
      </div>
    </div>
  );
};

export default PlanningPage;
